import { fromJS } from 'immutable';
import { SET_PREOPEN_MANAGER_PENDING_CLAIMS } from 'containers/PreOpenManagerPendingClaims/constants';
import { RESET_STORE } from 'containers/LoginPage/constants';

const initialState: any = fromJS({
  claims: [],
  countClaims: 0,
});

const PreOpenManagerPendingClaimsReducer = (
  state = initialState,
  action: any,
) => {
  switch (action.type) {
    case SET_PREOPEN_MANAGER_PENDING_CLAIMS:
      return state
        .set('claims', fromJS(action.response.claims))
        .set('countClaims', fromJS(action.response.total));
    case RESET_STORE:
      return initialState;
    default:
      return state;
  }
};

export default PreOpenManagerPendingClaimsReducer;
